import React, { useContext, useEffect, useState } from "react";
import { IDyspepsiaSymptomsDataPayload } from "../../../../../../types";
import { showToast } from "../../../../../../utils/utility";
import { useDirectusApi } from "../../../../../../libs/data-access";
import { useSearchParams } from "react-router-dom";
import { PatientContext } from "../../../../patientFromContext/PatientsContext";

export default function useDyspepsiaSymptoms() {
  const [searchParams] = useSearchParams();
  const patient_id = searchParams.get("patient_id");
  const visit_id = searchParams.get("visit_id");
  const { postDirectData, fetchDirectData, patchDirectData } = useDirectusApi();
  const {
    activeTab,
    isBtnNextClick,
    setIsBtnLoading,
    handleNextTab,
    isFormUpdating,
    setIsFormUpdating,
  } = useContext(PatientContext);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [gallStoneID, setGallStoneID] = useState<number | undefined>(undefined);

  const [errors, setErrors] = useState<any>({});



  const [documentedOn, setDocumentedOn] = React.useState<
    { label: string; value: number; selected: boolean }[]
  >([
    { label: "US", value: 1, selected: false },
    { label: "CT", value: 2, selected: false },
    { label: "MRI", value: 3, selected: false },
    { label: "Surgery", value: 4, selected: false },
  ]);

  const [symptomStatus, setSymptomStatus] = React.useState<
    { label: string; value: number; selected: boolean }[]
  >([
    { label: "None", value: 1, selected: false },
    { label: "Dyspepsia", value: 4, selected: false },
    { label: "Fat intolerance", value: 2, selected: false },
    {
      label: "Biliary colic (intense epigastric pain lasting >30 mins)",
      value: 7,
      selected: false,
    },
    { label: "Acute Cholecystitis", value: 8, selected: false },
    { label: "Biliary obstruction", value: 5, selected: false },
    { label: "Cholangitis", value: 3, selected: false },
    { label: "Acute pancreatitis", value: 6, selected: false },
    { label: "GBC", value: 9, selected: false },
  ]);

  const [severity, setSeverity] = React.useState<
    { label: string; value: number; selected: boolean }[]
  >([
    { label: "Mild", value: 1, selected: false },
    { label: "Moderate", value: 2, selected: false },
    { label: "Severe", value: 3, selected: false },
  ]);

  const [painDescription, setPainDescription] = React.useState<
    { label: string; value: number; selected: boolean }[]
  >([
    { label: "Acute", value: 1, selected: false },
    { label: "Insidious", value: 2, selected: false },
  ]);
  const [typeOfPain, setTypeOfPain] = React.useState<
    { label: string; value: number; selected: boolean; remarks: string }[]
  >([
    { label: "Constant", value: 1, selected: false, remarks: "" },
    { label: "Colic", value: 2, selected: false, remarks: "" },
  ]);

  const [typeOfPainRemarks, setTypeOfPainRemarks] = React.useState<string>("");

  const [painLocation, setPainLocation] = React.useState<
    { label: string; value: string; selected: boolean }[]
  >([
    { label: "Right hypochondrium", value: "", selected: false },
    { label: "Epigastric pain", value: "", selected: false },
    { label: "Upper abdomen", value: "", selected: false },
    { label: "Chest", value: "", selected: false },
    { label: "Upper back", value: "", selected: false },
    { label: "Others", value: "", selected: false },
  ]);

  const [painIntensity, setPainIntensity] = React.useState<
    { label: string; value: number; selected: boolean }[]
  >([
    { label: "Mild", value: 1, selected: false },
    { label: "Moderate", value: 2, selected: false },
    { label: "Severe", value: 3, selected: false },
  ]);

  const [painDuration, setPainDuration] = React.useState<
    { label: string; value: number; selected: boolean; remarks: string }[]
  >([
    { label: "<15 min", value: 1, selected: false, remarks: "" },
    { label: "15 min - 6 hrs", value: 2, selected: false, remarks: "" },
    { label: ">6 hrs", value: 3, selected: false, remarks: "" },
    { label: "Exact time", value: 4, selected: false, remarks: "" },
  ]);
  const [painRadiation, setPainRadiation] = React.useState<
    { label: string; value: string; selected: boolean }[]
  >([
    { label: "No radiation", value: "", selected: false },
    { label: "Back", value: "", selected: false },
    { label: "Interscapular", value: "", selected: false },
    { label: "Shoulder", value: "", selected: false },
    { label: "Others", value: "", selected: false },
  ]);

  const [precipitatedBy, setPrecipitatedBy] = React.useState<
    { label: string; value: string; selected: boolean }[]
  >([
    { label: "None", value: "", selected: false },
    { label: "Fatty meal", value: "", selected: false },
    { label: "Heavy meal", value: "", selected: false },
    { label: "Meal after prolonged fasting", value: "", selected: false },
    { label: "Others", value: "", selected: false },
  ]);

  const [nausea, setNausea] = React.useState<boolean>(false);
  const [vomiting, setVomiting] = React.useState<boolean>(false);

  const [painType, setPainType] = React.useState<
    { label: string; value: number; selected: boolean }[]
  >([
    { label: "Persistent", value: 1, selected: false },
    { label: "Intermittent", value: 2, selected: false },
  ]);

  const [descriptionOfSymptoms, setDescriptionOfSymptoms] =
    React.useState<string>("");

  const [frequency, setFrequency] = React.useState<
    { label: string; value: number; selected: boolean }[]
  >([
    { label: "Daily", value: 1, selected: false },
    { label: "Weekly", value: 2, selected: false },
    { label: "Monthly", value: 3, selected: false },
    { label: "Yearly", value: 4, selected: false },
    { label: "More than annual", value: 5, selected: false },
  ]);

  const [frequencyMoreThanAnnualDetails, setFrequencyMoreThanAnnualDetails] =
    useState<string>(""); //frequency_more_than_annual_details

  const [reliefOfPain, setReliefOfPain] = React.useState<
    { label: string; value: string; selected: boolean }[]
  >([
    { label: "Spontaneous", value: "spontaneous", selected: false },
    { label: "Home remedies", value: "home_remedies", selected: false },
    { label: "Oral medication", value: "oral_medication", selected: false },
    { label: "IV drugs", value: "iv_drugs", selected: false },
  ]);

  const [hospitalization, setHospitalization] = React.useState<"Required" | "Not Required" | "">("");
  const [totalNoOfHospitalization, setTotalNoOfHospitalization] =
    useState<string>("");

  const [associatedSymptoms, setAssociatedSymptoms] = React.useState<
    { label: string; value: number; selected: boolean }[]
  >([
    { label: "Jaundice", value: 5, selected: false },
    { label: "Pruritis", value: 10, selected: false },
    { label: "Fever/Rigors", value: 7, selected: false },
    { label: "Clay colored stools", value: 2, selected: false },
  ]);

  const [symptomsOfDyspepsia, setSymptomsOfDyspepsia] = React.useState<
    { label: string; selected: boolean; remarks: string; value: number }[]
  >([
    {
      label: "Bothersome epigastric pain",
      selected: false,
      remarks: "",
      value: 1,
    },
    {
      label: "Bothersome epigastric burning",
      selected: false,
      remarks: "",
      value: 2,
    },
    {
      label: "Bothersome early satiety",
      selected: false,
      remarks: "",
      value: 3,
    },
    {
      label: "Bothersome postprandial fullness",
      selected: false,
      remarks: "",
      value: 4,
    },
    {
      label: "Overall duration of symptoms ≥ 3m",
      selected: false,
      remarks: "",
      value: 5,
    },
    {
      label: "Criteria fulfilled for ≥ 6m",
      selected: false,
      remarks: "",
      value: 6,
    },
  ]);

  const [dyspepsiaScoringIndex, setDyspepsiaScoringIndex] = React.useState<
    { label: string; selected: boolean; score: string }[]
  >([
    { label: "Epigastric pain", selected: false, score: "" },
    { label: "Retrosternal pain", selected: false, score: "" },
    { label: "Regurgitation", selected: false, score: "" },
    { label: "Nausea", selected: false, score: "" },
    {
      label: "Vomiting",
      selected: false,
      score: "",
    },
    { label: "Belching", selected: false, score: "" },
    { label: "Early Satiety", selected: false, score: "" },
    { label: "Dysphagia", selected: false, score: "" },
  ]);

  const [finalLeadScoreForDyspepsia, setFinalLeadScoreForDyspepsia] =
    useState<string>("");

  const [scoringIndex, setScoringIndex] = React.useState<
    { label: string; selected: boolean; score: string }[]
  >([
    { label: "Very mild", selected: false, score: "1" },
    { label: "Mild", selected: false, score: "2" },
    { label: "Moderate", selected: false, score: "3" },
    { label: "Severe", selected: false, score: "4" },
    { label: "Very severe", selected: false, score: "5" },
  ]);

  const [stoolFreq, setStoolFreq] = React.useState<string>("");
  const [bristolStoolScore, setBristolStoolScore] = React.useState<{
    usual: string;
    worst: string;
  }>({
    usual: "",
    worst: "",
  });

  const [textInputs, setTextInputs] = useState({
    whenSurgeryDetected: "",
    durationOfStones: "",
    howWasItDetected: "",
    howWasItDetectedRemarks: "",
    durationOfSymptoms: "",
    frequencyOfSymptomsPerMonth: "",
  });



  const [gallstoneStatus, setGallstoneStatus] = useState<string>("");
  const [painAtNight, setPainAtNight] = useState<string>("");
  const [painAtExertion, setPainAtExertion] = useState<string>("");
  const [gallstoneFrequency, setGallstoneFrequency] = useState<{
    day: string;
    week: string;
    month: string;
    year: string;
    inFrequent: string;
  }>({
    day: "",
    week: "",
    month: "",
    year: "",
    inFrequent: "",
  });


  const getFieldError = (category: string, value: any) => {
    if (!value) return "";
    if (category === "bristol_stool_score") {
      if (isNaN(Number(value))) {
        return "Not a valid number";
      } else if (Number(value) > 7) {
        return "Score should be less than 7";
      }
    }
    return "";
  };

  const validateField = (category: string, subKey: string, value: any) => {
    const errorMsg = getFieldError(category, value);
    setErrors((prev: any) => {
      const categoryErrors = { ...(prev[category] || {}) };
      if (!errorMsg) {
        delete categoryErrors[subKey];
      } else {
        categoryErrors[subKey] = errorMsg;
      }
      return {
        ...prev,
        [category]: categoryErrors,
      };
    });
    return errorMsg;
  };

  const validateAll = () => {
    const newErrors: any = {
      bristol_stool_score: {},
    };
    let hasError = false;

    const usualErr = getFieldError("bristol_stool_score", bristolStoolScore.usual);
    const worstErr = getFieldError("bristol_stool_score", bristolStoolScore.worst);

    if (usualErr) {
      newErrors.bristol_stool_score.usual = usualErr;
      hasError = true;
    }
    if (worstErr) {
      newErrors.bristol_stool_score.worst = worstErr;
      hasError = true;
    }

    setErrors(newErrors);
    return hasError;
  };

  useEffect(() => {
    if (bristolStoolScore) {
      validateAll();
    }
  }, [bristolStoolScore]);


  useEffect(() => {
    if (isBtnNextClick && activeTab === "dyspepsia_symptoms") {
      handleSubmitGallstone();
    }
  }, [isBtnNextClick]);

  useEffect(() => {
    if (activeTab === "dyspepsia_symptoms") {
      getDetailsByVisitId();
    }
  }, [activeTab]);

  useEffect(() => {
    let count = 0;
    let dataArr = dyspepsiaScoringIndex.filter((e) => e?.selected);
    dataArr?.forEach((each) => {
      count = each?.score ? count + +each?.score : count;
    });
    setFinalLeadScoreForDyspepsia(
      count ? String(count) : ""
    );
  }, [dyspepsiaScoringIndex]);

  const handlePayloadForGallStonesForm = async (
    userId: string,
    visit_id: string
  ) => {
    let payload: IDyspepsiaSymptomsDataPayload = {
      user_id: userId,
      visit_id: visit_id,
      stool_frequency: stoolFreq,
      bristol_stool_usual_score: bristolStoolScore?.usual,
      bristol_stool_worst_score: bristolStoolScore?.worst,
      symptoms_of_dyspepsia: symptomsOfDyspepsia
        ?.filter((e) => e?.selected)
        ?.map((e) => ({
          symptoms_name: e?.label,
          is_symptom: e?.selected,
          remarks: e?.remarks,
        })),
      dyspepsia_scoring_index: dyspepsiaScoringIndex
        ?.filter((e) => e?.selected)
        .map((e) => ({
          dyspepsia_name: e?.label,
          status: e?.selected,
          score: e?.score,
        })),
      dyspepsia_final_score: finalLeadScoreForDyspepsia ?? "",
    };
    return payload;
  };

  //  APi Function

  const getDetailsByVisitId = async () => {
    setIsLoading(true);
    setErrors({});
    const res = await fetchDirectData(
      `items/gallstones_history?filter[visit_id][_eq]=${visit_id}`
    );
    if (res.isSuccess) {
      if (res?.data?.length) {
        setIsFormUpdating(true);
        let data: IDyspepsiaSymptomsDataPayload = res?.data[0];
        setGallStoneID(data?.id);
        setStoolFreq(data?.stool_frequency);
        setBristolStoolScore({
          usual: data?.bristol_stool_usual_score,
          worst: data?.bristol_stool_worst_score,
        });

        if (data?.symptoms_of_dyspepsia?.length) {
          let stateData = symptomsOfDyspepsia;
          data?.symptoms_of_dyspepsia?.forEach((e) => {
            const index = stateData.findIndex(
              (each) =>
                each?.label?.toLowerCase()?.replaceAll(" ", "_") ==
                e?.symptoms_name?.toLowerCase()?.replaceAll(" ", "_")
            );
            stateData[index].selected = true;
            stateData[index].remarks = e?.remarks;
          });
          setSymptomsOfDyspepsia(stateData);
        }
        setFinalLeadScoreForDyspepsia(data?.dyspepsia_final_score ?? 0);

        if (data?.dyspepsia_scoring_index?.length) {
          let stateData = dyspepsiaScoringIndex;
          data?.dyspepsia_scoring_index?.forEach((e) => {
            const index = stateData.findIndex(
              (each) =>
                each?.label?.toLowerCase()?.replaceAll(" ", "_") ==
                e?.dyspepsia_name?.toLowerCase()?.replaceAll(" ", "_")
            );
            stateData[index].selected = true;
            stateData[index].score = e?.score;
          });
          setDyspepsiaScoringIndex(stateData);
        }


      } else {
        setIsFormUpdating(false);
      }
    } else {
      showToast({
        type: "error",
        message: "Something went wrong",
      });
    }
    setIsLoading(false);
  };

  const handleSubmitGallstone = async () => {
    if (validateAll()) {
      showToast({
        type: "error",
        title: "Validation Error",
        message: "Please fix all validation errors before submitting.",
      });
      return;
    }
    if (patient_id && visit_id) {
      let payload: IDyspepsiaSymptomsDataPayload =
        await handlePayloadForGallStonesForm(patient_id, visit_id);
      setIsBtnLoading(true);
      if (isFormUpdating) {
        const res = await patchDirectData(
          `items/gallstones_history/${gallStoneID}`,
          payload
        );
        if (res.isSuccess) {
          showToast({
            type: "success",
            title: "gallstones history updated successfully",
            message: "Gallstones history Updated",
          });
          handleNextTab();
        } else {
          showToast({
            type: "error",
            message: res?.message || "Failed to add gallstones history",
          });
        }
      } else {
        const res = await postDirectData(`items/gallstones_history`, payload);
        if (res.isSuccess) {
          showToast({
            type: "success",
            title: "Added gallstones history successfully",
            message: "Gallstones history added",
          });
          handleNextTab();
        } else {
          showToast({
            type: "error",
            message: res?.message || "Failed to add gallstones history",
          });
        }
      }
      setIsBtnLoading(false);
    } else {
      showToast({
        type: "error",
        title: "Please try again",
        message: "User id not found !",
      });
    }
  };

  return {
    stoolFreq,
    setStoolFreq,
    bristolStoolScore,
    setBristolStoolScore,
    setGallstoneStatus,
    gallstoneStatus,
    symptomsOfDyspepsia,
    setSymptomsOfDyspepsia,
    dyspepsiaScoringIndex,
    setDyspepsiaScoringIndex,
    finalLeadScoreForDyspepsia,
    scoringIndex,
    errors,
    validateField,
  };
}
